export default __webpack_public_path__ + "images/FN.d79c597.png";